module.exports = __webpack_public_path__ + "static/camera.ee3c903f.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/floaters/camera.png
// module id = 1473
// module chunks = 168707334958949